package com.eladfinish.bible.contest.features.installTime.domain.model

data class InstallInfo(
    val firstInstallTimeMillis: Long,
    val lastUpdateTimeMillis: Long,
    val event: InstallEvent,
)
